import App from 'components/app';
import Home from 'components/home';
import rest from "api/rest";

import {Login, ListCategories, AddCategory, EditCategory, Notification, Validators} from "pages";
import {ListBusinesses, AddBusiness, EditBusiness, ListAwaitingBusinesses, ListRejectedBusinesses} from 'pages/businesses';
import {ListPromotions, AddPromotion, EditPromotion} from 'pages/promotions';
import {ListVideos, AddVideo, EditVideo} from 'pages/videos';
import {ListTopBusinesses, AddTopBusiness, EditTopBusiness} from 'pages/top-businesses';
import {ListArticles, AddArticle, EditArticle} from 'pages/articles';
import {ListArticleCategories, AddArticleCategory, EditArticleCategory} from 'pages/article-categories';
import {ListProductsByBusiness, AddProduct, EditProduct, ApprovedProducts, AwaitingProducts, RejectedProducts} from 'pages/products';
import {RequestsContainer, RequestDetail} from 'pages/requests';
import {DemandsContainer, DemandDetail} from 'pages/demands';
import {SubscriptionsContainer, SubscriptionMailContent} from 'pages/subscriptions';
import {ComplainsContainer, ComplainDetail} from 'pages/complains';
import {OrdersContainer, ClosedOrdersContainer, OrderDetailContainer, CancelledOrdersContainer} from 'pages/orders';
import {ContactsContainer} from 'pages/contacts';
import {UsersContainer, AddUser, EditUser} from 'pages/users';
import {ListFAQs, AddFAQ, EditFAQ} from 'pages/faqs';
import {ListHomeBanners, AddHomeBanner, EditHomeBanner} from 'pages/home-banners';
import {Fair, AddFair, DetailFair, EditFair, FairBannerCategory, FairAdsPage} from 'pages/fair';
import {FairBusiness, FairBusinessAwaiting, FairAddBusiness, FairBusinessReject} from 'pages/fair/fair-business';
import {FairProducts, FairProductsAwaiting, FairProductsOfBusiness, FairProductsReject, FairAddProduct, FairAddProductsOfBusiness} from 'pages/fair/fair-products';
import {FairOrders, FairOrdersClosed, FairOrdersCanceled, FairOrdersOfBusiness} from 'pages/fair/fair-orders';
import {EmailInvitePage, EmailApprovePage} from 'pages/fair/fair-emails';

const {actions} = rest;

const routes = [
  {
    component: App,
    routes: [
      {
        component: Login,
        exact: true,
        path: '/',
      },
      {
        path: "/home",
        exact: true,
        component: Home
      },
      {
        path: "/categories",
        exact: true,
        component: ListCategories,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/categories/add",
        exact: true,
        component: AddCategory,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/categories/edit/:id",
        exact: true,
        component: EditCategory,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/home-banners",
        exact: true,
        component: ListHomeBanners,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/home-banners/add",
        exact: true,
        component: AddHomeBanner,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/home-banners/edit/:id",
        exact: true,
        component: EditHomeBanner,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/businesses/awaiting",
        exact: true,
        component: ListAwaitingBusinesses,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses/rejected",
        exact: true,
        component: ListRejectedBusinesses,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses",
        exact: true,
        component: ListBusinesses,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses/add",
        exact: true,
        component: AddBusiness,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses/edit/:id",
        exact: true,
        component: EditBusiness,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/article-categories",
        exact: true,
        component: ListArticleCategories,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/add",
        exact: true,
        component: AddArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/edit/:id",
        exact: true,
        component: EditArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/business/:id/products",
        exact: true,
        component: ListProductsByBusiness,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/business/:id/products/add",
        exact: true,
        component: AddProduct,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/products/awaiting",
        exact: true,
        component: AwaitingProducts,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/products",
        exact: true,
        component: ApprovedProducts,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/products/rejected",
        exact: true,
        component: RejectedProducts,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/products/edit/:id",
        exact: true,
        component: EditProduct,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/article-categories",
        exact: true,
        component: ListArticleCategories,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/add",
        exact: true,
        component: AddArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/edit/:id",
        exact: true,
        component: EditArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/promotions",
        exact: true,
        component: ListPromotions,
        activeMenu: 'tin-bai'
      },
      {
        path: "/promotions/add",
        exact: true,
        component: AddPromotion,
        activeMenu: 'tin-bai'
      },
      {
        path: "/promotions/edit/:id",
        exact: true,
        component: EditPromotion,
        activeMenu: 'tin-bai'
      },
      
      {
        path: "/videos",
        exact: true,
        component: ListVideos,
        activeMenu: 'tin-bai'
      },
      {
        path: "/videos/add",
        exact: true,
        component: AddVideo,
        activeMenu: 'tin-bai'
      },
      {
        path: "/videos/edit/:id",
        exact: true,
        component: EditVideo,
        activeMenu: 'tin-bai'
      },

      {
        path: "/top-businesses",
        exact: true,
        component: ListTopBusinesses,
        activeMenu: 'top-business'
      },
      {
        path: "/top-businesses/add",
        exact: true,
        component: AddTopBusiness,
        activeMenu: 'top-business'
      },
      {
        path: "/top-businesses/edit/:id",
        exact: true,
        component: EditTopBusiness,
        activeMenu: 'top-business'
      },
      {
        path: "/articles",
        exact: true,
        component: ListArticles,
        activeMenu: 'tin-bai'
      },
      {
        path: "/articles/add",
        exact: true,
        component: AddArticle,
        activeMenu: 'tin-bai'
      },
      {
        path: "/articles/edit/:id",
        exact: true,
        component: EditArticle,
        activeMenu: 'tin-bai'
      },
      {
        path: "/faqs",
        exact: true,
        component: ListFAQs,
        activeMenu: 'tin-bai'
      },
      {
        path: "/faqs/add",
        exact: true,
        component: AddFAQ,
        activeMenu: 'tin-bai'
      },
      {
        path: "/faqs/:id",
        exact: true,
        component: EditFAQ,
        activeMenu: 'tin-bai'
      },
      // requests
      {
        path: "/requests",
        exact: true,
        component: RequestsContainer,
        activeMenu: 'quan-ly-yeu-cau'
      },
      // requests
      {
        path: "/requests/:id",
        exact: true,
        component: RequestDetail,
        activeMenu: 'quan-ly-yeu-cau'
      },
      // demands
      {
        path: "/demands",
        exact: true,
        component: DemandsContainer,
        activeMenu: 'quan-ly-nhu-cau-dang'
      },
      // demands
      {
        path: "/demands/:id",
        exact: true,
        component: DemandDetail,
        activeMenu: 'quan-ly-nhu-cau-dang'
      },
      // demands
      {
        path: "/subscriptions",
        exact: true,
        component: SubscriptionsContainer,
        activeMenu: 'danh-ba-nhan-tin'
      },
      // demands
      {
        path: "/subscriptions/content",
        exact: true,
        component: SubscriptionMailContent,
        activeMenu: 'danh-ba-nhan-tin'
      },
      // demands
      {
        path: "/complains",
        exact: true,
        component: ComplainsContainer,
        activeMenu: 'khieunai-gopy'
      },
      // demands
      {
        path: "/complains/:id",
        exact: true,
        component: ComplainDetail,
        activeMenu: 'khieunai-gopy'
      },
      {
        path: "/orders",
        exact: true,
        component: OrdersContainer,
        activeMenu: 'quan-ly-don-hang'
      },
      {
        path: "/orders/closed",
        exact: true,
        component: ClosedOrdersContainer,
        activeMenu: 'quan-ly-don-hang'
      },
      {
        path: "/orders/cancelled",
        exact: true,
        component: CancelledOrdersContainer,
        activeMenu: 'quan-ly-don-hang'
      },

      {
        path: "/orders/:id",
        exact: true,
        component: OrderDetailContainer,
        activeMenu: 'quan-ly-don-hang'
      },
      {
        path: "/contacts",
        exact: true,
        component: ContactsContainer,
        activeMenu: 'thong-tin-lien-he'
      },
      // Manage users
      // products
      {
        path: "/users",
        exact: true,
        component: UsersContainer,
        activeMenu: 'quan-ly-nguoi-dung'
      },
      {
        path: "/users/:id/edit",
        exact: true,
        component: EditUser,
        activeMenu: 'quan-ly-nguoi-dung'
      },
      {
        path: "/users/add",
        exact: true,
        component: AddUser,
        activeMenu: 'quan-ly-nguoi-dung'
      }
      // fair
      ,
      {
        path: "/fairs",// danh sách hội chợ
        exact: true,
        component: Fair,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/add",// thêm mới hội chợ
        exact: true,
        component: AddFair,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/edit",// chỉnh sửa hội chợ
        exact: true,
        component: EditFair,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id",//chi tiết hội chợ
        exact: true,
        component: DetailFair,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/businesses",//danh sách doanh nghiệp của hội chợ
        exact: true,
        component: FairBusiness,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/business/add",//thêm mới doanh nghiệp cho hội chợ
        exact: true,
        component: FairAddBusiness,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/businesses/awaiting",//danh sách doanh nghiệp đang chờ duyệt của hội chợ
        exact: true,
        component: FairBusinessAwaiting,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/businesses/reject",//danh sách doanh nghiệp không được tham gia hội chợ
        exact: true,
        component: FairBusinessReject,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/products",//danh sách sản phẩm của hội chợ
        exact: true,
        component: FairProducts,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/products/add",//Thêm mới sản phẩm cho hội chợ
        exact: true,
        component: FairAddProduct,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/products/:idProduct/edit",//Chỉnh sửa sản phẩm của hội chợ
        exact: true,
        component: FairAddProduct,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/products/awaiting",//danh sách sản phẩm đang chờ duyệt của hội chợ
        exact: true,
        component: FairProductsAwaiting,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/products/reject",//danh sách sản phẩm không được tham gia hội chợ
        exact: true,
        component: FairProductsReject,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/business/:idBusiness/products",// danh sách sản phẩm của doanh nghiệp trong hội chợ
        exact: true,
        component: FairProductsOfBusiness,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/business/:idBusiness/products/add",// thêm mới sản phẩm của doanh nghiệp vào hội chợ
        exact: true,
        component: FairAddProductsOfBusiness,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/orders",//danh sách đơn hàng chưa xử lý của hội chợ
        exact: true,
        component: FairOrders,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/orders/closed",//danh sách đơn hàng đã xử lý của hội chợ
        exact: true,
        component: FairOrdersClosed,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/orders/canceled",//danh sách đơn hàng đã hủy của hội chợ
        exact: true,
        component: FairOrdersCanceled,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/business/:idBusiness/orders",// danh sách đơn hàng chưa xử lý của doanh nghiệp trong hội chợ
        exact: true,
        component: FairOrdersOfBusiness,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/banner-category",// Quản lý banner danh mục
        exact: true,
        component: FairBannerCategory,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/ads",// Quản lý Quảng cáo hội chợ
        exact: true,
        component: FairAdsPage,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/email-invite",// Quản lý email mời doanh nghiệp tham gia hội chợ
        exact: true,
        component: EmailInvitePage,
        activeMenu: 'quan-ly-hoi-cho'
      },{
        path: "/fair/:id/email-approve",// Quản lý email thông báo khi đồng ý doanh nghiệp tham gia hội chợ
        exact: true,
        component: EmailApprovePage,
        activeMenu: 'quan-ly-hoi-cho'
      }


    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./routes/routes.js